export default __webpack_public_path__ + "static/media/anastasia.e1adf3d6.jp2";